import { StatusCartFilterRequest } from '@/main/models/request/quoteStatusFilterRequest';
import { KeyValueEnum } from '@/main/models/common';
import {
  ReportScheduleStatusActionTypes,
  ReportScheduleStatusTypes
} from './reportScheduleStatusTypes';

export function getReportScheduleStatus(): ReportScheduleStatusActionTypes {
  return {
    type: ReportScheduleStatusTypes.GET_REPORT_SCHEDULE_STATUS
  };
}

export function saveReportScheduleStatus(
  data: KeyValueEnum[] | null,
  isError: boolean,
  errorMessages: string[] | null
): ReportScheduleStatusActionTypes {
  return {
    type: ReportScheduleStatusTypes.SAVE_REPORT_SCHEDULE_STATUS,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerReportScheduleStatus(): ReportScheduleStatusActionTypes {
  return {
    type: ReportScheduleStatusTypes.RESET_REDUCER_REPORT_SCHEDULE_STATUS
  };
}

